<template>
  <div>
    <el-dialog title="晨豪软件及服务协议" :visible.sync="visible" width="100%"
               :modal="false" center :close-on-click-modal="false">
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item title="首部及导言" name="1">
          <div class="typesetting">
            欢迎使用北京晨豪科技有限公司（以下简称“北京晨豪公司”）软件及服务！
          </div>
          <div class="typesetting">
            为使用北京晨豪公司软件及服务，贵单位应当阅读并遵守《北京晨豪科技软件许可及服务协议》（以下简称“本协议”）。请贵单位务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通是使用某项服务的单独协议，并选择接收或者不接受。限制、免责条款可能以加粗形式提示贵单位注意。
          </div>
          <div class="typesetting">
            除非贵单位已阅读并接受本协议所有条款，否则贵单位无权安装或使用本软件及相关服务。贵单位的下载、安装、使用、登录等行为即视为贵单位已阅读并同意本协议的约束。
          </div>
        </el-collapse-item>
        <el-collapse-item title="一、协议的范围" name="2">
          <div class="typesetting bold">1.1协议适用主体范围：</div>
          <div class="typesetting">本协议适用于北京晨豪公司下载、安装、使用、登录本软件，以及使用本服务所订立的协议的人员。</div>
          <div class="typesetting bold">1.2协议关系及冲突条款：</div>
          <div class="typesetting">
            本协议的内容，包括但不限于以下与本服务、本协议相关的协议、规则、规范以及北京晨豪公司可能不断发布的关于本服务的相关协议、规则、规范等内容，前述内容一经正式发布，即为本协议不可分割的组成部分，与其构成统一整体，贵单位同样应当遵守。
          </div>
        </el-collapse-item>
        <el-collapse-item title="二、关于本服务" name="3">
          <div class="typesetting bold">2.1本服务内容：</div>
          <div class="typesetting">
            本服务内容是指北京晨豪公司通过本软件向用户提供的相关服务（简称“本服务”）。
          </div>
          <div class="typesetting">2.2本服务形式;</div>
          <div class="typesetting">
            贵单位可能通过电脑、手机等终端以客户端、网页等形式使用本服务，具体以北京晨豪公司提供的为准，同时，北京晨豪公司会不断丰富贵单位使用本服务的终端、形式等。当贵单位使用本服务时，贵单位应选择与贵单位的终端、系统等相匹配的本软件版本，否则，贵单位可能无法正常使用本服务。
          </div>
          <div class="typesetting bold">2.3许可的范围：</div>
          <div class="typesetting">
            2.3.1北京晨豪公司给予贵单位一项不可转让及非排他性的许可，以使用本软件。贵单位可以在合同所签署项目安装、使用、登录本软件。
          </div>
          <div class="typesetting">
            2.3.2本条及本协议其他条款未明示授权的其它一切权利仍由北京晨豪公司保留，贵单位在行使这些权力时须另外取得北京晨豪公司的书面许可。北京晨豪公司如果未行使前述任何权利，并不构成对该权利的放弃。
          </div>
        </el-collapse-item>
        <el-collapse-item title="三、软件的获取" name="4">
          <div class="typesetting">
            3.1贵单位与北京晨豪公司签订软件服务合同是获取本软件是唯一合法的途径。
          </div>
          <div class="typesetting">
            3.2如果贵单位从未经北京晨豪公司授权的第三方获取本软件或本软件名称相同的安装程序，北京晨豪公司无法保证该软件能够正常使用，并因此给贵单位造成的损失不予负责。
          </div>
        </el-collapse-item>
        <el-collapse-item title="四、软件的更新" name="5">
          <div class="typesetting">
            4.1为了增进用户体验，完善服务内容，北京晨豪公司有可能提供新的服务，并为贵单位有时间约定并有限度提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。
          </div>
          <div class="typesetting">
            4.2 北京晨豪公司提供两年免费软件升级服务，之后维护及升级需付费。
          </div>
          <div class="typesetting bold">用户个人信息保护</div>
          <div class="typesetting">4.3
            保护用户信息是北京晨豪公司的一项基本原则，北京晨豪公司会采取合理的措施保护用户的信息。除法律法规规定的情形外，未经用户许可北京晨豪公司不会向第三方公开，透露用户信息。
          </div>
          <div class="typesetting">4.4 一般情况下，贵单位可以随时浏览、修改自己的信息，但出于安全性和身份识别的考虑，贵单位修改关键信息时，可能有些必要的验证措施。</div>
        </el-collapse-item>
        <el-collapse-item title="五、用户行为规范" name="6">
          <div class="typesetting bold">5.1用户注意事项：</div>
          <div class="typesetting">
            5.1.1贵单位充分理解并同意：贵单位在使用本服务某一项特定服务时，本服务可以使用贵单位终端设备的相关权限、接口及相关信息等实现相应的功能，某些特定服务可能还需同意单独的协议、规则等，贵单位在使用该项服务前请仔细阅读前述相关协议、规则。
          </div>
          <div class="typesetting">
            5.1.2贵单位充分理解并同意：本服务记录的所有操作行为都和注册账号关联，这代表该账户在本服务做的所有操作都默认为是本单位人员操作，本单位人员应对操作结果负责。
          </div>
          <div class="typesetting bold">5.2用户禁止行为：</div>
          <div class="typesetting bold">
            除非法律允许或者北京晨豪公司书面许可，贵单位不得从事下列行为:
          </div>
          <div class="typesetting">(1)删除本软件中的信息数据；</div>
          <div class="typesetting">
            (2)对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；
          </div>
          <div class="typesetting">
            (3)对北京晨豪公司拥有知识产权的内容进行使用、出租、修改、汇编、发表和无以商业用途为目的等；
          </div>
          <div class="typesetting">
            (4)对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务端的交互数据，以及本软件运行所必须的系统数据，进行复制、修改、增加、删除或创作任何衍生作品；
          </div>
          <div class="typesetting">
            (5)自行授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰；
          </div>
          <div class="typesetting">
            (6)其他未经北京晨豪公司明示授权、许可或违反本协议及相关协议、规则的行为。
          </div>
          <div class="typesetting bold">5.3对自己行为负责：</div>
          <div class="typesetting">
            贵单位充分了解并同意，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。
          </div>
          <div class="typesetting bold">5.4违约处理：</div>
          <div class="typesetting">
            如果北京晨豪公司发现或收到别人举报贵单位有违反本协议约定的，北京晨豪公司有权采取包括但不限于暂停、终止贵单位使用本服务，追究法律责任等措施。
          </div>
        </el-collapse-item>
        <el-collapse-item title="六、其他" name="7">
          <div class="typesetting">
            <strong>6.1贵单位使用本软件或本服务即视为贵单位已阅读并同意接收本协议的约束。</strong>
            北京晨豪公司有权在必要时修改本协议条款，贵单位可以在本软件、本服务的最新版本中查阅相关协议条款，本协议条款变更后，如果贵单位继续使用本软件或本服务，即视为贵单位已接受修改后的协议。如果贵单位不接受修改后的协议，应当停止使用本软件。
          </div>
          <div class="typesetting">6.2本协议签订地为中华人民共和国北京市。</div>
          <div class="typesetting">
            6.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
          </div>
          <div class="typesetting bold">
            6.4若贵单位和北京晨豪公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，贵单位同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
          </div>
          <div class="typesetting">
            6.5本协议所有条款的标题仅为阅读方便，本身无实际涵义，不能作为本协议涵义解释的依据。
          </div>
          <div class="typesetting">
            6.6本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['isShow'],
  data () {
    return {
      visible: false,
      activeNames: ['1'],
    }
  },
  watch: {
    isShow (val) {
      this.visible = val
    }
  }

}
</script>

<style scoped>
.typesetting {
  text-indent: 2em;
}

.bold {
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/login/Agreement.vue